const GA_ID = "G-L5W4MFV4NZ";
const CONSENT_KEY = "mira-cookie-consent";

let loaded = false;

const hasConsent = () => localStorage.getItem(CONSENT_KEY) === "all";

const loadGtag = () => {
  if (loaded || !GA_ID) return;
  loaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { anonymize_ip: true });
};

export const initGA = () => {
  if (hasConsent()) loadGtag();
};

export const gaConsentGranted = () => {
  loadGtag();
};

export const gaPageView = (path) => {
  if (!loaded || !window.gtag) return;
  window.gtag("event", "page_view", { page_path: path, page_location: window.location.href });
};

export const gaEvent = (name, params = {}) => {
  if (!loaded || !window.gtag) return;
  window.gtag("event", name, params);
};
